<template>
    <div>
        <Language :add="add" v-model="form.lang" @change="getDetail"></Language>
        <el-form label-width="100px" :model="form" ref="form" :rules="rules">
            <el-form-item label="推送类型" required> {{ { 1: "邮箱", 3: "站内信" }[form.category] }} </el-form-item>
            <el-form-item v-if="form.category == 3" label="封面图" prop="cover">
                <Uploader v-model="form.cover"></Uploader>
            </el-form-item>
            <el-form-item label="标题" prop="title">
                <el-input v-model="form.title" style="width: 300px" placeholder="请输入标题"></el-input>
            </el-form-item>
            <el-form-item v-if="form.category == 1" label="收件人" prop="label">
                <LabelSelector multiple v-model="form.label"></LabelSelector>
            </el-form-item>
            <el-form-item label="内容" prop="content">
                <Editor v-model="form.content" placeholder="请输入内容"></Editor>
            </el-form-item>
            <el-form-item v-if="form.category == 1" label="" prop="publish_time">
                <el-radio-group v-model="push_type">
                    <el-radio label="1">定时发布</el-radio>
                </el-radio-group>
                <el-date-picker
                    style="margin-left: 10px"
                    v-model="form.publish_time"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetime"
                    placeholder="选择日期时间"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button style="width: 120px" type="primary" @click="save">发布</el-button>
                <el-button style="width: 120px" @click="back">返回</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { add, detail } from "@/api/msg/list";
import Editor from "@/components/Editor.vue";
import Language from "@/components/Language.vue";
import Uploader from "@/components/Uploader.vue";
import LabelSelector from "@/components/LabelSelector.vue";
import { getUuid } from "@/jslibs/utils";
export default {
    components: { Editor, Language, LabelSelector, Uploader },
    data() {
        return {
            form: {
                lang: "zh",
                category: "",
                title: "",
                content: "",
                cover: "",
                label: [],
                publish_time: "",
            },
            push_type: "1",
            id: null,
            rules: {},
            add: true,
        };
    },
    mounted() {
        this.form.category = this.$route.query.category;
        this.form.cuuid = getUuid();
    },
    methods: {
        getDetail() {
            detail({ cuuid: this.form.cuuid, lang: this.form.lang }).then(({ code, result, error }) => {
                if (code === 200) {
                    if (result) {
                        this.add = false;
                        this.form = { ...result };
                    } else {
                        this.form = { cuuid: this.form.cuuid, lang: this.form.lang, category: this.form.category };
                    }
                } else {
                    this.$message.error(error.message);
                }
            });
        },
        save() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;

                const params = {
                    ...this.form,
                };
                add(params).then(({ code, error }) => {
                    if (code === 200) {
                        this.$message.success("添加成功");
						this.back();
                    } else {
                        this.$message.error(error.message);
                    }
                });
            });
        },
        back() {
            this.$router.back();
        },
    },
};
</script>

<style></style>
